<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle del suaje</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
      <home-delete-button></home-delete-button>
    </template>
  </main-buttons-bar>

  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Fecha creacion'"
        :spanColumn="4"
        :data="swage.FechaCreacion ? getDate('dd/mm/yyyy', swage.FechaCreacion) : ''"
      ></custom-data>
      <custom-data
        :label="'Código'"
        :spanColumn="4"
        :data="swage ? swage.CodigoSuaje : ''"
      ></custom-data>
      <custom-data
        :label="'Código adicional'"
        :spanColumn="4"
        :data="swage && swage.CodigoAdicional ? swage.CodigoAdicional : ''"
      ></custom-data>
      <custom-data
        :label="'Descripción'"
        :spanColumn="6"
        :data="swage && swage.Descripcion ? swage.Descripcion : ''"
      ></custom-data>
      <custom-data
        :label="'Activo'"
        :spanColumn="3"
        :data="swage.Activo ? 'Si' : 'No'"
      ></custom-data>
      <custom-data
        :label="'Automatica'"
        :spanColumn="3"
        :data="swage.EsAutomatica ? 'Si' : 'No'"
      ></custom-data>
      <custom-data
        :label="'Corte completo'"
        :spanColumn="4"
        :data="swage.EsCorteCompleto ? 'Si' : 'No'"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Forma'"
        :spanColumn="4"
        :data="swage && swage.Forma && swage.Forma.Descripcion ? swage.Forma.Descripcion : ''"
      ></custom-data>
      <custom-data
        :label="'Tipo Suaje'"
        :spanColumn="4"
        :data="
          swage && swage.SuajeTipo && swage.SuajeTipo.Descripcion ? swage.SuajeTipo.Descripcion : ''
        "
      ></custom-data>
      <custom-data
        :label="'Tipo cilindro'"
        :spanColumn="4"
        :data="
          swage && swage.CilindroTipo && swage.CilindroTipo.Descripcion
            ? swage.CilindroTipo.Descripcion
            : ''
        "
      ></custom-data>
      <custom-data
        :label="'Pleca'"
        :spanColumn="4"
        :data="swage.TienePleca ? 'Si' : 'No'"
      ></custom-data>
      <custom-data
        :label="'Item'"
        :spanColumn="4"
        :data="swage && swage.Material ? swage.Material.Descripcion : 'no especifica'"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <custom-data
        :label="'Medida Eje (mm)'"
        :spanColumn="4"
        :data="swage.MedidaEjeMm ? swage.MedidaEjeMm : ''"
      ></custom-data>
      <custom-data
        :label="'Medida Desarrollo (mm)'"
        :spanColumn="4"
        :data="swage.MedidaDesarrolloMm ? swage.MedidaDesarrolloMm : ''"
      ></custom-data>
      <custom-data
        :label="'Gap Eje (mm)'"
        :spanColumn="4"
        :data="swage.GapEjeMm ? swage.GapEjeMm : ''"
      ></custom-data>
      <custom-data
        :label="'Gap desarrollo (mm)'"
        :spanColumn="4"
        :data="swage.GapDesarrolloMm ? swage.GapDesarrolloMm : ''"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Medida Eje (In)'"
        :spanColumn="4"
        :data="swage.MedidaEjeIn ? swage.MedidaEjeIn : ''"
      ></custom-data>
      <custom-data
        :label="'Medida Desarrollo (In)'"
        :spanColumn="4"
        :data="swage.MedidaDesarrolloIn ? swage.MedidaDesarrolloIn : ''"
      ></custom-data>
      <custom-data
        :label="'Gap Eje (In)'"
        :spanColumn="4"
        :data="swage.GapEjeIn ? swage.GapEjeIn : ''"
      ></custom-data>
      <custom-data
        :label="'Gap desarrollo (In)'"
        :spanColumn="4"
        :data="swage.GapDesarrolloIn ? swage.GapDesarrolloIn : ''"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="24">
      <custom-data
        :label="'Engranaje'"
        :spanColumn="4"
        :data="swage ? swage.Engranaje : ''"
      ></custom-data>
      <custom-data
        :label="'Etiquetas eje'"
        :spanColumn="4"
        :data="swage ? swage.EtiquetasEje : ''"
      ></custom-data>
      <custom-data
        :label="'Etiquetas desarrollo'"
        :spanColumn="4"
        :data="swage ? swage.EtiquetasDesarrollo : ''"
      ></custom-data>
      <custom-data
        :label="'Ancho'"
        :spanColumn="4"
        :data="swage ? swage.AnchoOptimoMaterial : ''"
      ></custom-data>
      <custom-data
        :label="'Desarrollo'"
        :spanColumn="4"
        :data="swage ? swage.Desarrollo : ''"
      ></custom-data>
    </el-row>
    <el-row :gutter="24">
      <custom-data
        :label="'Minimo etiqueta impresa'"
        :spanColumn="4"
        :data="swage ? swage.MinEtiquetaImpresa : '-'"
      ></custom-data>
      <custom-data
        :label="'Minimo etiqueta sin impresion'"
        :spanColumn="4"
        :data="swage ? swage.MinEtiquetaSinImpresion : '-'"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="24">
      <custom-data
        style="white-space: pre-line"
        :label="'Familia'"
        :spanColumn="24"
        :data="descripcionFamilias ? descripcionFamilias : ''"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="24">
      <custom-data
        style="white-space: pre-line"
        :label="'Observaciones'"
        :spanColumn="24"
        :data="swage && swage.Observaciones ? swage.Observaciones : ''"
      ></custom-data>
    </el-row>
  </detail-container>
</template>

<script setup>
import {
  onBeforeMount,
  computed,
  onMounted,
} from 'vue';
import { useSwageStore } from '@/stores/swage_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
import getDate from '@/shared/components/utils.js';
const swageStore = useSwageStore();
const { findSuajeByCodigoHTTP, findAClaseSuajeByCodigoHTTP } = swageStore;
const { swage, claseSuajeSelected } = storeToRefs(swageStore);
const route = useRoute();
const router = useRouter();

// local state
const items = [
  { label: 'Inicio', to: '/page/swage/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const editItem = () => router.replace(`/page/swage/edit/${route.params.id}`);

const descripcionFamilias = computed(() => {
  if (swage.value && swage.value.SuajeMateriaPrimaFamilia) {
    return swage.value.SuajeMateriaPrimaFamilia.map(
      (item) => item.MateriaPrimaFamilia.Descripcion,
    ).join('\n'); // Separador de salto de línea
  }
  return '';
});

onBeforeMount(() => {
  const id = route.params.id;
  if (id && +id > 0) {
    findSuajeByCodigoHTTP(id);
  }
});

onMounted(async () => {
  await new Promise((resolve) => {
    const checkValue = () => {
      if (swage.value.CodigoClaseSuaje !== 0 && swage.value.CodigoClaseSuaje !== null) {
        resolve();
      } else {
        setTimeout(checkValue, 100); // Verificar cada 100 ms
      }
    };
    checkValue();
  });
  findAClaseSuajeByCodigoHTTP(swage.value.CodigoClaseSuaje);
});
</script>

<style scoped></style>
